import { css } from 'styled-components';
import { theme } from '@frameio/vapor';

export const ASSET_BG_COLOR = theme.colors.background.primary;
export const HOVER_COLOR = theme.colors.border.tertiary;
export const FOCUSED_COLOR = theme.colors.border.interactive.focused;
export const SELECTED_COLOR = theme.colors.background.interactive.brandMedium;
export const ACTIVATED_BORDER_COLOR = theme.colors.border.interactive.selected;

export const sharedStyles = css`
  &[aria-disabled] {
    opacity: 0.2;
    pointer-events: none;
  }
  &[data-dragging-over] {
    *,
    *::after,
    *::before {
      pointer-events: none !important;
    }
  }
  &[data-in-cut-operation='true'] {
    opacity: 0.5;
  }
  cursor: pointer;
  outline: none;
  user-select: none;
`;
